<section class="mt-4">
  <div class="card mb-4" [ngClass]="borderClass">
    <div class="card-header" [ngClass]="backgroundClass">
      {{ workspaceStateTranslations['HEADER'] }}
    </div>

    <div class="card-body">
      <div class="row p-2 d-flex justify-content-around">
        <button
          [disabled]="workspaceStateLoading"
          type="button"
          class="btn me-1 col-lg-3 col-xs-12 mb-lg-0 mb-2"
          [ngClass]="buttonClass"
          (click)="saveWorkspaceState()"
        >
          <span class="fa fa-paperclip"></span>
          {{ workspaceStateTranslations['SAVE'] }}
        </button>

        <button
          [disabled]="workspaceStateLoading"
          type="button"
          class="btn col-lg-3 col-xs-12"
          [ngClass]="buttonClass"
          (click)="loadWorkspaceState()"
        >
          <span class="fa fa-inbox"></span>
          {{ workspaceStateTranslations['RESTORE'] }}
        </button>
      </div>
    </div>

    @if (workspaceMsgTxt) {
      <div class="card-footer">
        <div class="d-flex flex-column">
          <span [ngClass]="'text-' + workspaceMsgType">
            @if (workspaceStateLoading) {
              <i class="fa fa-spinner fa-pulse fa-fw"></i>
            }
            {{ workspaceMsgTxt }}</span
          >
        </div>
      </div>
    }
  </div>
</section>
